// extracted by mini-css-extract-plugin
export default {"warn":"Warn_warn__Xel8O","icon":"Warn_icon__NYSaM","title":"Warn_title__kQVaL","big":"Warn_big__ZtOx7","description":"Warn_description__2R6K+"};